var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeciallyAbledAssistance = function SvgSpeciallyAbledAssistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.65 7.804a1.2 1.2 0 1 1 0 2.4H9.335l.415 2.838c.022.205.194.36.4.362h1.942a2.787 2.787 0 0 1 2.788 2.547l.268 3.748a1.2 1.2 0 1 1-2.392.192l-.268-3.735a.395.395 0 0 0-.4-.352H10.15a2.81 2.81 0 0 1-2.776-2.429l-.612-4.197a1.2 1.2 0 0 1 1.187-1.374zm4.201-1.209a2.4 2.4 0 0 1 2.4 2.4v11.2a.8.8 0 1 1-1.6 0v-11.2a.8.8 0 1 0-1.6 0v.598a.8.8 0 1 1-1.6 0v-.598a2.4 2.4 0 0 1 2.4-2.4m-6.102 10.2a.8.8 0 1 1 0 1.6h-5.2a.8.8 0 1 1 0-1.6zm-2.8-14.59a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })));
};
export default SvgSpeciallyAbledAssistance;